import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './styles.scss';

// Props
const propTypes = {
  children: PropTypes.node.isRequired,
};

function Wysiwyg({ children }) {
  return (
    <div className="wysiwyg">
      {children}
    </div>
  );
}

Wysiwyg.propTypes = propTypes;

export default Wysiwyg;



// WEBPACK FOOTER //
// ./src/app/components/tools/wysiwyg/Wysiwyg.js